/**
 * Accounts that used or added a passkey in this browser. The sign-in server offers a passkey to
 * every address so it can't be used to probe accounts, which leaves the page unable to tell who
 * has one. This device can: an account on this list gets its passkey prompt as soon as the email
 * is entered, everyone else gets the password field. Deliberately survives sign-out, like a
 * remembered username.
 */
const KEY = "mt-passkey-accounts";
const MAX = 5;

const normalize = (email: string) => email.trim().toLowerCase();

function read(): string[] {
    try {
        const list = JSON.parse(localStorage.getItem(KEY) || "[]");
        return Array.isArray(list) ? list.filter(item => typeof item === "string") : [];
    } catch {
        return [];
    }
}

export function hasPasskeyHint(email?: string): boolean {
    return !!email && read().includes(normalize(email));
}

export function rememberPasskey(email?: string) {
    if (!email) return;
    const account = normalize(email);
    localStorage.setItem(KEY, JSON.stringify([account, ...read().filter(item => item !== account)].slice(0, MAX)));
}

export function forgetPasskey(email?: string) {
    if (!email) return;
    const account = normalize(email);
    localStorage.setItem(KEY, JSON.stringify(read().filter(item => item !== account)));
}
